import React from "react";

interface VehicleDetailsSectionProps {
  data?: any;
}

const defaultData = {
  specs: {
    exteriorColor: "Lunar Blue",
    interiorColor: "Macchiato Beige Exclusive Nappa Leather",
    milesIncluded: 150,
    milesWhenInService: 20237,
    transmission: "Automatic",
    fuelType: "Premium Unleaded",
  },
};

const VehicleDetailsSection: React.FC<any> = ({ data = defaultData }) => {
  const vehicleData = {
    ...defaultData,
    ...data,

    specs: { ...defaultData.specs, ...(data?.specs || {}) },
  };
  const [showAll, setShowAll] = React.useState(false);

  return (
    <>
      {data?.description ||
        data?.color ||
        data?.interior_color ||
        data?.year ||
        data?.seats ||
        data?.doors ||
        data?.miles_allowed_per_day ||
        data?.miles_allowed_per_trip ||
        data?.previous_miles ||
        data?.transmission_type ||
        data?.fuel_type || data?.features.length > 0 ? (
        <>
          <section className=" text-text-color w-full flex flex-col rounded-md sm:border-b sm:border-t sm:border-l sm:border-r border-neutral-200  space-y-6 sm:space-y-8 pb-2 px-0 sm:p-4 xl:p-8 ">
            <div className="">
              {data?.description && (
                <div>
                  <h2 className="text-2xl  font-semibold mb-6">
                    General Description
                  </h2>
                  {(() => {
                    const desc = data?.description;
                    const charLimit = 450;
                    if (!desc) return null;
                    if (showAll || desc.length <= charLimit) {
                      return (
                        <>
                          <p className="text-text-color text-md leading-relaxed mb-4">
                            {desc}
                          </p>
                          {desc.length > charLimit && (
                            <button
                              className="font-bold underline mt-2"
                              onClick={() => setShowAll(false)}
                            >
                              VIEW LESS
                            </button>
                          )}
                        </>
                      );
                    } else {
                      return (
                        <>
                          <p className="text-text-color text-md leading-relaxed mb-4">
                            {desc.slice(0, charLimit)}...
                          </p>
                          <button
                            className="font-bold underline mt-2"
                            onClick={() => setShowAll(true)}
                          >
                            VIEW MORE
                          </button>
                        </>
                      );
                    }
                  })()}
                </div>
              )}
              {/* Vehicle Description */}
              {data?.color ||
                data?.interior_color ||
                data?.year ||
                data?.seats ||
                data?.doors ||
                data?.miles_allowed_per_day ||
                data?.miles_allowed_per_trip ||
                data?.previous_miles ||
                data?.transmission_type ||
                data?.fuel_type ? (
                <div className="mb-2">
                  <h2 className="text-2xl  font-semibold mb-6">
                    Vehicle Information
                  </h2>
                  <div className="grid grid-cols-1 gap-4">
                    {data?.color && (
                      <div className="flex justify-between items-center pb-2 border-b border-neutral-200">
                        <span className="text-text-color text-sm font-semibold">
                          EXTERIOR COLOR
                        </span>
                        <span className="text-text-color font-semibold">
                          {data.color}
                        </span>
                      </div>
                    )}
                    {data?.interior_color && (
                      <div className="flex justify-between items-center pb-2 border-b border-neutral-200">
                        <span className="text-text-color text-sm font-semibold">
                          INTERIOR COLOR
                        </span>
                        <span className="text-text-color font-semibold text-right w-full sm:w-auto">
                          {data?.interior_color}
                        </span>
                      </div>
                    )}

                    {(data?.miles_allowed_per_day ||
                      data?.miles_allowed_per_trip) && (
                        <div className="flex justify-between items-center pb-2 border-b border-neutral-200">
                          <span className="text-text-color text-sm font-semibold">
                            MILES INCLUDED
                          </span>
                          <span className="text-text-color font-semibold">
                            {data?.miles_allowed_default === "per_day"
                              ? `${data?.miles_allowed_per_day} miles/day`
                              : `${data?.miles_allowed_per_trip} miles/trip`}
                          </span>
                        </div>
                      )}
                    {data?.year && (
                      <div className="flex justify-between items-center pb-2 border-b border-neutral-200">
                        <span className="text-text-color text-sm font-semibold">
                          YEAR
                        </span>
                        <span className="text-text-color font-semibold">
                          {data?.year}
                        </span>
                      </div>
                    )}
                    {data?.seats && (
                      <div className="flex justify-between items-center pb-2 border-b border-neutral-200">
                        <span className="text-text-color text-sm font-semibold">
                          SEATING CAPACITY
                        </span>
                        <span className="text-text-color font-semibold">
                          {data?.seats} seats
                        </span>
                      </div>
                    )}
                    {data?.doors && (
                      <div className="flex justify-between items-center pb-2 border-b border-neutral-200">
                        <span className="text-text-color text-sm font-semibold">
                          NUMBER OF DOORS
                        </span>
                        <span className="text-text-color font-semibold">
                          {data?.doors} doors
                        </span>
                      </div>
                    )}
                    {data?.transmission_type && (
                      <div className="flex justify-between items-center pb-2 border-b border-neutral-200">
                        <span className="text-text-color text-sm font-semibold">
                          TRANSMISSION
                        </span>
                        <span className="text-text-color font-semibold">
                          {data?.transmission_type}
                        </span>
                      </div>
                    )}
                    {data?.fuel_type && (
                      <div className="flex justify-between items-center pb-2 border-b border-neutral-200">
                        <span className="text-text-color text-sm font-semibold">
                          FUEL TYPE
                        </span>
                        <span className="text-text-color font-semibold">
                          {data?.fuel_type}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              ) : null}

              {data?.features && data.features.length > 0 && (
                <div>
                  <h2 className="text-2xl  font-semibold mb-6">
                    Additional Features:
                  </h2>
                  <ul className="list-disc pl-6 space-y-2">
                    {data?.features?.map((item: any, idx: number) => (
                      <li key={idx}>{item.name}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </section>
        </>
      ) : null}
    </>
  );
};

export default VehicleDetailsSection;
